var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FunnelLiabilityChange',_vm._b({},'FunnelLiabilityChange',_vm.funnelData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }